import React, { useEffect } from "react";
import { useGetBenchLocationsMutation } from "../../../redux/services/external/apiExternal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setBenchData } from "../../../redux/slice/home/sliceHome";
import Loader from "../../Container/Components/Loader";

const SelectBench = () => {
  const { language } = useSelector((state) => state.sliceLanguage);
  const { benchData } = useSelector((state) => state.sliceHome);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [getBenchLocations, { data: benchLocations, error, isLoading }] =
    useGetBenchLocationsMutation();

  useEffect(() => {
    const fetchBenchLocations = async () => {
      try {
        await getBenchLocations().unwrap();
      } catch (err) {
        console.error("Error fetching bench locations:", err);
      }
    };
    fetchBenchLocations();
  }, [getBenchLocations]);

  const getTranslationBenchName = (benchName) => {
    if (!benchName) return "";
    const hindiMap = {
      AMRAVATI: "अमरावती",
      ERNAKULAM: "एर्नाकुलम",
      JAIPUR: "जयपुर",
      MUMBAI: "मुंबई",
    };
    if (language === "hi") {
      return hindiMap[benchName] || benchName;
    }
    return benchName;
  };

  if (isLoading) {
    return <Loader />;
  }

  const handleSelectChange = (event) => {
    const selectedBenchCode = event.target.value;
    if (selectedBenchCode) {
      dispatch(setBenchData(selectedBenchCode));
      navigate(`/${selectedBenchCode.toLowerCase()}`);
    }
  };
  return (
    <>
      <div className="col-3">
        <select
          className="form-select custom-select-bench branch-select"
          aria-label="Default select example"
          onChange={handleSelectChange}
          value={benchData}
        >
          <option hidden>Select Branch</option>
          {isLoading && <option>Loading benches...</option>}
          {error && <option>Error loading benches</option>}
          {Array.isArray(benchLocations?.data) &&
          benchLocations.data.length > 0 ? (
            benchLocations.data.map((bench) => (
              <option
                key={bench.railway_bench_name}
                value={bench.railway_bench_code}
              >
                {getTranslationBenchName(bench.railway_bench_name)}
              </option>
            ))
          ) : (
            <option>No benches available</option>
          )}
        </select>
      </div>
    </>
  );
};

export default SelectBench;
